
import Vue from 'vue';
export default Vue.extend({
  name: 'snackbar',
  props: {
    messages: {
      type: Array,
      default: () => {
        [];
      },
    },
    color: {
      type: String,
      default: 'success',
    },
    timeout: {
      type: Number,
      default: 5000,
    },
    hock: {
      type: Function,
    },
  },
  watch: {
    messages(newVal) {
      if (newVal) {
        this.snackbar = true;
      }
    },
  },
  data: () => ({
    snackbar: false,
  }),
});
